import { TooltipWrapper } from '../adminComponents';
import { AiCallFailedIcon, AiCallSuccessIcon } from '../assets';

export const AiCallIconTooltip = ({
  resultFailed,
}: {
  resultFailed: boolean;
}) => {
  if (resultFailed) {
    return (
      <TooltipWrapper
        tooltip="AI call failed"
        style={{ width: '32px', height: '24px' }}
      >
        <AiCallFailedIcon />
      </TooltipWrapper>
    );
  }
  return (
    <TooltipWrapper
      tooltip="AI call successful"
      style={{ width: '32px', height: '24px' }}
    >
      <AiCallSuccessIcon />
    </TooltipWrapper>
  );
};
